import '@a-ui/core/dist/main.css';
import '@a-ui/flexboxgrid/dist/flexboxgrid.min.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import store from './store';
import { UserProvider } from 'contexts/User';

import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
      <UserProvider>
        <App/>
      </UserProvider>
  </Provider>
);
